<script lang="ts" setup>
import DescriptorItem from '@/components/domain/DescriptorItem.vue';
import StatementList from '@/components/domain/StatementList.vue';
import type { DescriptorVM } from '@/types/view';
import { ref, toRef, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';


const props = defineProps<{
    descriptors: DescriptorVM[];
    isRoot?: boolean;
    currentRoot?: string | null | undefined;
}>()

const emit = defineEmits<{
  (e: "root-selected", v: string | null): void;
  (e: "answer-all", v: DescriptorVM | null): void;
}>();

const {t} = useI18n();
const isRoot = toRef(props, 'isRoot')
const descriptors = toRef(props, 'descriptors')
const expanded = ref<string[]>([]);

if(props.isRoot) {
  watchEffect(() => {
    if(props.currentRoot) {
      expanded.value = [props.currentRoot];
    } else {
      expanded.value = [];
    }
  })
}

const isExpanded = (descriptor: DescriptorVM): boolean => {
  return expanded.value.find((d) => d == descriptor.id) ? true : false;
}

function toggleExpand(descriptor: DescriptorVM) : void {
  if (expanded.value.find((d) => d == descriptor.id)) {
    expanded.value = expanded.value.filter((d) => d != descriptor.id);
  } else {
    expanded.value.push(descriptor.id);
    if(isRoot) emit("root-selected", descriptor.id);
  }
}

</script>

<template>
  <div class="descriptor-list-wrapper">
    <template v-for="descriptor in descriptors" :key="descriptor.id">
      <DescriptorItem :descriptor=descriptor @click="toggleExpand(descriptor)" :is-expanded="isExpanded(descriptor)" :is-root="isRoot"></DescriptorItem>
      <div v-if="descriptor.descriptors && expanded.includes(descriptor.id)">
        <div class="sublist">
          <div v-if="descriptor.statements" class="statement-list-wrapper">
            <StatementList :statements="descriptor.statements"></StatementList>
          </div>
          <DescriptorList :descriptors="descriptor.descriptors" :is-root="false"></DescriptorList>
        </div>
        <div v-if="isRoot" class="actions">
          <button class="answer-all" :class="{continue: descriptor.evaluatedStatementCount == 0}" @click="emit('answer-all', descriptor)">{{ $t('common.answer-all') }}</button>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.sublist {
  margin-left: 1em;
}
.actions {
  padding-bottom: 8px;
}
.answer-all {
  width: 50%;
  margin-left: auto;
}

</style>
